if (!customElements.get('gm-energy-information')) {
  customElements.define('gm-energy-information', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('[data-energy-open]').forEach((link) => {
        link.setAttribute('aria-haspopup', 'dialog');
        link.setAttribute('aria-controls', this.dialog.id);
        link.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          this.opener = link;
          this.dialog.showModal();
          document.body.classList.add('gm-energy-dialog-open');
        }, options);
      });
      this.querySelector('[data-energy-close]')?.addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.unlockPage();
        if (this.opener?.isConnected) this.opener.focus();
      }, options);
      this.querySelectorAll('[data-energy-language]').forEach((button) => {
        button.addEventListener('click', () => {
          const language = button.dataset.energyLanguage;
          this.querySelectorAll('[data-energy-language]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          this.querySelectorAll('[data-energy-document]').forEach((item) => { item.hidden = item.dataset.energyDocument !== language; });
        }, options);
      });
      this.querySelectorAll('.gm-energy__download').forEach((link) => {
        link.addEventListener('click', async (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          if (link.getAttribute('aria-busy') === 'true') return;
          link.setAttribute('aria-busy', 'true');
          try {
            const response = await fetch(link.href, { signal: this.controller.signal });
            if (!response.ok) throw new Error('Energy label unavailable');
            const url = URL.createObjectURL(await response.blob());
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = new URL(link.href).pathname.split('/').pop() || 'energy-label.jpg';
            anchor.click();
            setTimeout(() => URL.revokeObjectURL(url), 30000);
          } catch (error) {
            if (error.name !== 'AbortError') window.open(link.href, '_blank', 'noopener');
          } finally {
            link.removeAttribute('aria-busy');
          }
        }, options);
      });
    }
    unlockPage() {
      if (!document.querySelector('gm-energy-information dialog[open]')) document.body.classList.remove('gm-energy-dialog-open');
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
      this.unlockPage();
    }
  });
}
